"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MenuItem_1 = require("./MenuItem");
const { root, selected, focusVisible } = MenuItem_1.menuItemClasses;
const MuiMenuItemOverrides = {
    MuiMenuItem: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}`]: {
                    color: theme.palette.gray[800],
                    fontWeight: 500,
                    minWidth: '220px',
                    padding: '8px 16px',
                },
                [`&.${root}.${focusVisible}`]: {
                    backgroundColor: theme.palette.common.white,
                },
                [`&.${root}:hover`]: {
                    backgroundColor: theme.palette.gray[100],
                },
                [`&.${root}.${selected}`]: {
                    backgroundColor: theme.palette.blue[100],
                    fontWeight: 700,
                },
            }),
        },
    },
};
exports.default = MuiMenuItemOverrides;
//# sourceMappingURL=MuiMenuItemOverrides.js.map